import React from 'react';
import { PRIVATE_LEADERBOARD_PLAYER_NAME } from 'common/commonEnum';
import './PrivateLeaderboardPlayerLabel.scss';

/**
 * Wordmark checkmark glyph (path from assets/images/SlotCheck-landing.svg),
 * used in place of the letters C-h-e-c-k — not the yellow boxed check icon.
 */
export const SLOT_CHECK_PLAYER_ICON_SRC = 'assets/icon/slot-check-wordmark-check.svg';

export function isPrivateLeaderboardPlayerName(name?: string | null): boolean {
  return name === PRIVATE_LEADERBOARD_PLAYER_NAME;
}

interface PrivateLeaderboardPlayerLabelProps {
  className?: string;
}

/** Renders Slot + check icon + player for private leaderboard accounts. */
export const PrivateLeaderboardPlayerLabel: React.FC<PrivateLeaderboardPlayerLabelProps> = ({
  className,
}) => {
  const classes = ['private-leaderboard-player-label', className].filter(Boolean).join(' ');

  return (
    <span className={classes} aria-label={PRIVATE_LEADERBOARD_PLAYER_NAME}>
      Slot{' '}
      <img
        src={SLOT_CHECK_PLAYER_ICON_SRC}
        alt=""
        className="private-leaderboard-player-label__icon"
        aria-hidden="true"
      />{' '}
      player
    </span>
  );
};

interface LeaderboardPlayerNameProps {
  name: string;
  className?: string;
}

/** Public aliases as text; private sentinel as Slot + check icon + player. */
export const LeaderboardPlayerName: React.FC<LeaderboardPlayerNameProps> = ({
  name,
  className,
}) => {
  if (isPrivateLeaderboardPlayerName(name)) {
    return <PrivateLeaderboardPlayerLabel className={className} />;
  }

  if (className) {
    return <span className={className}>{name}</span>;
  }

  return <>{name}</>;
};

export default PrivateLeaderboardPlayerLabel;
